import { studyGroupsApi } from "@/lib/humhub-api/studyGroups";
import { usePaginatedStudyGroups } from "@/hooks/usePaginatedStudyGroups";

export const useChatSelectableStudyGroups = (
  initialPage = 1,
  initialPerPage = 20,
) => {
  const { data, isLoading, error, refetch } = usePaginatedStudyGroups({
    initialPage,
    initialPerPage,
    queryKey: "chatSelectableStudyGroups",
    queryFn: (page, perPage) =>
      studyGroupsApi.getChatSelectableStudyGroups(page, perPage),
    staleTime: 3 * 60 * 1000,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
